import {useEffect} from "react"
import {loadZendeskSnippet, ZENDESK_SCRIPT_ID, ze} from "./zendeskWidget"

const UNIT_ZENDESK_URL = "https://static.zdassets.com/ekr/snippet.js?key=8de81817-a025-4757-832b-d69a46dcb582"

const useUnitZendesk = (shouldInitialize = false) => {
	useEffect(() => {
		if (!shouldInitialize) {
			return
		}

		return loadZendeskSnippet({
			id: ZENDESK_SCRIPT_ID,
			src: UNIT_ZENDESK_URL,
			onReady: () => {
				ze("messenger", "show")
			},
		})
	}, [shouldInitialize])
}

export default useUnitZendesk
